module.exports = __webpack_public_path__ + "img/about-us.5dad2fa8.png";